import { Action, createReducer, on } from '@ngrx/store';
import * as DeviceVctActions from './device-vct.actions';
import { Plant } from 'src/app/model/device-vct/device-vct-implant';
import { InvitationVct } from 'src/app/model/device-vct/device-vct-invitations';
import { Site } from 'src/app/model/site';


export interface State {
    sitesList: Site[];
    plantsList: Plant[];
    invitationsList: InvitationVct[];
    loadingDevicesVctList: boolean;
    loadingInvitations: boolean;
    loadingSitesVctList: boolean;

    deviceVctSharing: boolean;
    deviceVctShared: boolean;
    deviceVctDeleted: boolean;
    deviceVctDeleting: boolean;
    deviceVctPlantEditing: boolean;
    deviceVctPlantEdited: boolean;
    deviceVctModuleEditing: boolean;
    deviceVctModuleEdited: boolean;
    deviceVctFeatureEditing: boolean;
    deviceVctFeatureEdited: boolean;
    deviceVctAuxEdited: boolean;
    editSystem: boolean;
    deviceVctInvitationAppReseting: boolean;
    deviceVctInvitationAppReseted: boolean;
    deviceVctMassiveSharing: boolean;
    deviceVctMassiveShared: boolean;
}

const initialState: State = {
    sitesList: [],
    plantsList: [],
    invitationsList: [],
    loadingDevicesVctList: false,
    loadingInvitations: false,
    deviceVctSharing: false,
    deviceVctShared: false,
    deviceVctDeleted: false,
    deviceVctDeleting: false,
    deviceVctModuleEditing: false,
    deviceVctModuleEdited: false,
    deviceVctPlantEditing: false,
    deviceVctPlantEdited: false,
    deviceVctFeatureEditing: false,
    deviceVctFeatureEdited: false,
    deviceVctAuxEdited: false,
    editSystem: false,
    deviceVctInvitationAppReseting: false,
    deviceVctInvitationAppReseted: false,
    deviceVctMassiveSharing: false,
    deviceVctMassiveShared: false,
    loadingSitesVctList: false,
};

const deviceVctReducer = createReducer(
    initialState,

    on(DeviceVctActions.getDevicesVctList, (state) => ({
        ...state,
        plantsList: [],
        deviceVctDeleting: false, deviceVctDeleted: false, loadingDevicesVctList: true,
    })),
    on(DeviceVctActions.getDevicesVctListSuccess, (state, payload) => ({
        ...state,
        plantsList: payload.plantsList,
        deviceVctDeleting: false, deviceVctDeleted: false, loadingDevicesVctList: false,
    })),
    on(DeviceVctActions.getDevicesVctListFailed, (state) => ({
        ...state,
        plantsList: [],
        deviceVctDeleting: false, deviceVctDeleted: false, loadingDevicesVctList: false,
    })),
    on(DeviceVctActions.getVctInvitations, (state) => ({
        ...state,
        invitationsList: [],
        deviceVctDeleting: false, deviceVctDeleted: false, loadingInvitations: true,
    })),
    on(DeviceVctActions.getVctInvitationsSuccess, (state, payload) => ({
        ...state,
        invitationsList: payload.invitationsList,
        deviceVctDeleting: false, deviceVctDeleted: false, loadingInvitations: false,
    })),
    on(DeviceVctActions.getVctInvitationsFailed, (state) => ({
        ...state,
        invitationsList: [],
        deviceVctDeleting: false, deviceVctDeleted: false, loadingInvitations: false,
    })),
    on(DeviceVctActions.createVctInvitationsReset, (state) => ({
        ...state,
        deviceVctSharing: false, deviceVctShared: false,
    })),
    on(DeviceVctActions.createVctInvitations, (state) => ({
        ...state,
        deviceVctSharing: true, deviceVctShared: false,
    })),
    on(DeviceVctActions.createVctInvitationsSuccess, (state) => ({
        ...state,
        deviceVctSharing: false, deviceVctShared: true,
    })),
    on(DeviceVctActions.createVctInvitationsFailed, (state) => ({
        ...state,
        deviceVctSharing: false, deviceVctShared: false,
    })),
    on(DeviceVctActions.removeVctInvitations, (state) => ({
        ...state,
        deviceVctDeleting: true, deviceVctDeleted: false,
    })),
    on(DeviceVctActions.removeVctInvitationsSuccess, (state) => ({
        ...state,
        deviceVctDeleting: false, deviceVctDeleted: true,
    })),
    on(DeviceVctActions.removeVctInvitationsFailed, (state) => ({
        ...state,
        deviceVctDeleting: false, deviceVctDeleted: false,
    })),

    on(DeviceVctActions.editVctModuleNameReset, (state) => ({
        ...state,
        deviceVctModuleEditing: false, deviceVctModuleEdited: false,
    })),
    on(DeviceVctActions.editVctModuleName, (state) => ({
        ...state,
        deviceVctModuleEditing: true, deviceVctModuleEdited: false,
    })),
    on(DeviceVctActions.editVctModuleNameSuccess, (state) => ({
        ...state,
        deviceVctModuleEditing: false, deviceVctModuleEdited: true,
    })),
    on(DeviceVctActions.editVctModuleNameFailed, (state) => ({
        ...state,
        deviceVctModuleEditing: false, deviceVctModuleEdited: false,
    })),

    on(DeviceVctActions.editVctFeatureNameReset, (state) => ({
        ...state,
        deviceVctFeatureEditing: false, deviceVctFeatureEdited: false,
    })),
    on(DeviceVctActions.editVctFeatureName, (state) => ({
        ...state,
        deviceVctFeatureEditing: true, deviceVctFeatureEdited: false,
    })),
    on(DeviceVctActions.editVctFeatureNameSuccess, (state) => ({
        ...state,
        deviceVctFeatureEditing: false, deviceVctFeatureEdited: true,
    })),
    on(DeviceVctActions.editVctFeatureNameFailed, (state) => ({
        ...state,
        deviceVctFeatureEditing: false, deviceVctFeatureEdited: false,
    })),
    on(DeviceVctActions.enableVctAux, (state) => ({
        ...state,
        deviceVctAuxEdited: false,
    })),
    on(DeviceVctActions.enableVctAuxSuccess, (state) => ({
        ...state,
        deviceVctAuxEdited: true,
    })),
    on(DeviceVctActions.editVctAux, (state) => ({
        ...state,
        deviceVctAuxEdited: false,
    })),
    on(DeviceVctActions.editVctAuxSuccess, (state) => ({
        ...state,
        deviceVctAuxEdited: true,
    })),
    on(DeviceVctActions.disableVctAux, (state) => ({
        ...state,
        deviceVctAuxEdited: false,
    })),
    on(DeviceVctActions.disableVctAuxSuccess, (state) => ({
        ...state,
        deviceVctAuxEdited: true,
    })),
    on(DeviceVctActions.getSitesVctList, (state) => ({
        ...state,
        sitesList: [],
        loadingSitesVctList: true,
    })),
    on(DeviceVctActions.getSitesVctListSuccess, (state, payload) => ({
        ...state,
        sitesList: payload.sitesList,
        loadingSitesVctList: false,
    })),
    on(DeviceVctActions.getSitesVctListListFailed, (state) => ({
        ...state,
        sitesList: [],
        loadingSitesVctList: false,
    })),
    on(DeviceVctActions.enableEditSystem, (state, payload) => ({
        ...state,
        editSystem: payload.editSystem,
    })),
    on(DeviceVctActions.resetVctInvitationApp, (state) => ({
        ...state,
        deviceVctInvitationAppReseting: true, deviceVctInvitationAppReseted: false,
    })),
    on(DeviceVctActions.resetVctInvitationAppSuccess, (state) => ({
        ...state,
        deviceVctInvitationAppReseting: false, deviceVctInvitationAppReseted: true,
    })),
    on(DeviceVctActions.resetVctInvitationAppFailed, (state) => ({
        ...state,
        deviceVctInvitationAppReseting: false, deviceVctInvitationAppReseted: false,
    })),
    on(DeviceVctActions.massiveVctInvitationsReset, (state) => ({
        ...state,
        deviceVctMassiveSharing: false, deviceVctMassiveShared: false,
    })),
    on(DeviceVctActions.massiveVctInvitations, (state) => ({
        ...state,
        deviceVctMassiveSharing: true, deviceVctMassiveShared: false,
    })),
    on(DeviceVctActions.massiveVctInvitationsSuccess, (state) => ({
        ...state,
        deviceVctMassiveSharing: false, deviceVctMassiveShared: true,
    })),
    on(DeviceVctActions.massiveVctInvitationsFailed, (state) => ({
        ...state,
        deviceVctMassiveSharing: false, deviceVctMassiveShared: false,
    })),

    on(DeviceVctActions.abandonVctPlant, (state) => ({
        ...state,
        deviceVctPlantEditing: true, deviceVctPlantEdited: false,
    })),
    on(DeviceVctActions.abandonVctPlantSuccess, (state) => ({
        ...state,
        deviceVctPlantEditing: false, deviceVctPlantEdited: true,
    })),
    on(DeviceVctActions.abandonVctPlantFailed, (state) => ({
        ...state,
        deviceVctPlantEditing: false, deviceVctPlantEdited: false,
    })),

    on(DeviceVctActions.abandonVctModule, (state) => ({
        ...state,
        deviceVctModuleEditing: true, deviceVctModuleEdited: false,
    })),
    on(DeviceVctActions.abandonVctModuleSuccess, (state) => ({
        ...state,
        deviceVctModuleEditing: false, deviceVctModuleEdited: true,
    })),
    on(DeviceVctActions.abandonVctModuleFailed, (state) => ({
        ...state,
        deviceVctModuleEditing: false, deviceVctModuleEdited: false,
    })),


    on(DeviceVctActions.abandonVctFeature, (state) => ({
        ...state,
        deviceVctFeatureEditing: true, deviceVctFeatureEdited: false,
    })),
    on(DeviceVctActions.abandonVctFeatureSuccess, (state) => ({
        ...state,
        deviceVctFeatureEditing: false, deviceVctFeatureEdited: true,
    })),
    on(DeviceVctActions.abandonVctFeatureFailed, (state) => ({
        ...state,
        deviceVctFeatureEditing: false, deviceVctFeatureEdited: false,
    })),
);

export const reducer = (state: State | undefined, action: Action): State => deviceVctReducer(state, action);

